export default function courseCard() {
  const $list = document.querySelectorAll('.courses-grid .course');
  $list.forEach(($course) => {
    const $header = $course.querySelector('.course-header');

    function showVideo() {
      const $iframe = $header.querySelector('iframe');
      const $video = $header.querySelector('.video');
      const $figure = $header.querySelector('figure');

      if ($iframe) {
        $iframe.src = $iframe.dataset.src;
        $figure.style.opacity = 0;
        $video.style.opacity = 1;
      }
    }

    function hideVideo() {
      const $iframe = $header.querySelector('iframe');
      const $video = $header.querySelector('.video');
      const $figure = $header.querySelector('figure');

      if ($iframe) {
        $iframe.src = '';
        $figure.style.opacity = 1;
        $video.style.opacity = 0;
      }
    }

    $header.addEventListener('mouseenter', showVideo);
    $header.addEventListener('mouseleave', hideVideo);
  });
}



// WEBPACK FOOTER //
// ./assets/js/modules/courseCard.js